import createLoader from '@signal/utils/createLoader'
import { loadSaga, listenSaga } from './sagas'

export const authLoader = createLoader('auth', {
  load: loadSaga,
  listen: listenSaga
})
